import { render, staticRenderFns } from "./BarTenderPrinter.vue?vue&type=template&id=d489c874&scoped=true&"
import script from "./BarTenderPrinter.vue?vue&type=script&lang=js&"
export * from "./BarTenderPrinter.vue?vue&type=script&lang=js&"
import style0 from "./BarTenderPrinter.vue?vue&type=style&index=0&id=d489c874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d489c874",
  null
  
)

export default component.exports